
// components
import GridPageAbstract from '../../abstract/GridPageAbstract';
import { filtersIpListStatuses } from '../statuses';

export default class FiltersIpListPage extends GridPageAbstract {
    constructor(props) {
        super(props);
        this.Name = 'filtersIpList';
        this.Server = this.props.context.getState().server.filtersIpList;
        this.MenuDisplayType = 'menu';
        this.searchFields = ['ipCidr', 'status'];
        this.showDatePicker = false;

        this.Head = localStorage[`head_${this.Name}`]
            ? JSON.parse(localStorage[`head_${this.Name}`])
            : [
                {
                    id: 'ipCidr',
                    label: 'ipCidr',
                    alignRight: false,
                    cell: 'Text',
                    displayGrid: true
                },
                {
                    id: 'status',
                    label: 'status',
                    alignRight: false,
                    cell: 'State',
                    items: Object.keys(filtersIpListStatuses),
                    displayGrid: true
                }
            ];
        this.state = {
            ...this.state,
            head: this.Head
        };
    }
}

